import gql from 'graphql-tag'

export const fetchCartQuery = gql(`
query ($cart_id: String!) {
  cart(
      cart_id: $cart_id
  ) {
    free_beer_active
    sap_payment_details
    note_for_driver
    customer_order_number
    delivery_date
    delivery_method
    outlet_details {
      payer_name
      outlet_name
      street
      city
      country
      province
      postalcode
      sap_id
    }
    payer_details {
      payername
      street
      city
      country
      zipcode
      sap_id
      identification_no
      taxvat
    }
    progress_bar_data {
      color
      sSpecialOfferDeliverableFlag
      sSpecialOfferLayerFlag
      sHighMarginAvgValue
      sHighMarginFlag
      cashDiscount  {
        cashamount
        isactive
        canshow
      }
      brand_progressbar {
        brand
        sub_brand
        hectolitres
        cases
      }
      isFullTruck
      isHalfTruck
      isSmallOrder
      isCheckoutEnable
      boolIncludeWeightCalculation
      iMinimumOrderPallet
      iMaximumOrderPallet
      iMinimumOrderWeight
      iMaximumOrderWeight
      sOutletDeliveryMethod
      iTotalCartWeight
      iTotalCartPalletQty
      iTotalCartVoulume
      iTotalFreeItems
      status
      can_show_layer_notice
    }
    cart_prices {
      grand_total_price
      grand_total_price_with_vat
      total_discount_basic
      total_discount_cash
      total_discount_packaging
      total_discount_promotional
      free_beer_total
      total_vat
      summary
    }
    id
    email
    total_quantity
    ship_to_id
    grand_total_your_price_details
    quantity_totals
    items {      
      id
      uid
      is_free_beer
      prices {
        price_details
        multi_deposit_details
        total_item_discount {
          value
        }
        price {
          value
        }
        
        row_total {
          value
        }
        discounts {
          label
          amount {
            value
          }
        }
      }
      product {
        hectolitres_fe
        additional_weight
        free_beer
        favourites
        related_products {        
          uid
          name
          sku    
          number_of_products_on_layer
          disable_for_pallet_ordering_fe
          disable_for_layer_ordering_fe
          number_of_products_on_layer
          number_of_layers_per_pallet
          catalog_product_name
          hectolitres_fe
          additional_weight
          product_last
          product_new
          product_sale
          product_recommended
          promotional
          favourites
          high_margin
          swatch_image
          your_price
          cart_fields {
            packaging_cart
            layer_cart
            pallets_cart
            total_units
          }
          free_beer_details          
          {
            id
            req_id
            qty
            product_id
            free_beer
            iSameFreeProductAlreadyInCart
            disable
            remainingqty
            item_id
          }
          small_image {
            url
          }
          thumbnail {
            url
          }
          image {
            url
          }
          media_gallery {
            url
          }
        }
        free_beer_details
        {
          id
          req_id
          qty
          product_id
          free_beer
          iSameFreeProductAlreadyInCart
          disable
          remainingqty
          item_id
        }
        special_offer_details{
          max_purchasable_qty
          valid_from
          valid_to
          deliverable_from
          deliverable_to
          deliverable_flag
          layer_error_flag
        }
        low_stock_pl {
          is_lowstock
          out_of_stock
          rotation_day
          quantity
        }
        id
        name
        high_margin
        product_sale
        product_new
        product_recommended
        promotional
        product_lowstock
        free_beer
        catalog_product_name
        sku
        disable_for_layer_ordering_fe
        disable_for_pallet_ordering_fe
        url_key
        material_type
        number_of_items_in_box
        number_of_items_on_pallet
        swatch_image
        number_of_products_on_layer
        number_of_layers_per_pallet
        quantity_selector_layer
        quantity_selector_pallet
        isavailable_truck_package_ordering
        image {
          url
        }
        ... on BundleProduct {
          bundle_price_details
        }
        __typename
      }
      ... on BundleCartItem {
          bundle_options {
            uid
            label
            type
            values {
              id
              label
              price
              quantity
            }
          }
        }
      quantity
      quantity_total
      number_of_packages
      number_of_layer_freebeer
      number_of_layer
      number_of_layer_total
      number_of_pallet
      pack_format
      
    }
    prices {
      discounts {
        amount {
          value
        }
        label
      }
      grand_total {
        value
      }
    }
    empties{
      packaging_name
      packaging_volume
      packaging_issued
      number_of_units
      unit_of_measure
      total
    }
    cart_blga {
      packaging_name
      packaging_volume
      number_of_units
      unit_of_measure
      total
    }
  }
}
`)
